/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-misused-promises */

import { useMutation, gql } from '@apollo/client';
import { useCallback } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { addAlert } from '../../utils/alerts';
import { useTracker } from '../../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
export const SUBMIT_CANCELLATION_MUTATION = ("__gql__", "{\"kind\":\"Document\",\"definitions\":[{\"kind\":\"OperationDefinition\",\"operation\":\"mutation\",\"name\":{\"kind\":\"Name\",\"value\":\"SubmitCancellationMutation\"},\"variableDefinitions\":[{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"objectId\"}},\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"Long\"}}}}],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"alias\":{\"kind\":\"Name\",\"value\":\"response\"},\"name\":{\"kind\":\"Name\",\"value\":\"cancelPaymentsSubscription\"},\"arguments\":[{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"input\"},\"value\":{\"kind\":\"ObjectValue\",\"fields\":[{\"kind\":\"ObjectField\",\"name\":{\"kind\":\"Name\",\"value\":\"objectId\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"objectId\"}}}]}}],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"updatedObject\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"id\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"allProperties\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"id\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"value\"}}]}}]}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"userErrors\"}}]}}]}}]}", {
  id: null,
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "mutation",
    name: {
      kind: "Name",
      value: "SubmitCancellationMutation"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "objectId"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "Long"
          }
        }
      }
    }],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        alias: {
          kind: "Name",
          value: "response"
        },
        name: {
          kind: "Name",
          value: "cancelPaymentsSubscription"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "input"
          },
          value: {
            kind: "ObjectValue",
            fields: [{
              kind: "ObjectField",
              name: {
                kind: "Name",
                value: "objectId"
              },
              value: {
                kind: "Variable",
                name: {
                  kind: "Name",
                  value: "objectId"
                }
              }
            }]
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "updatedObject"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "id"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "allProperties"
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "id"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "value"
                    }
                  }]
                }
              }]
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "userErrors"
            }
          }]
        }
      }]
    }
  }]
});
export function useCancellationMutation(objectId, onClose) {
  const {
    trackUsage
  } = useTracker();
  const handleError = useCallback(async () => {
    addAlert({
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "subscriptions.SubscriptionCancellationModal.errorCancelingTitle"
      }),
      message: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "subscriptions.SubscriptionCancellationModal.errorCancelingMessage"
      }),
      type: 'danger'
    });
    await onClose();
  }, [onClose]);
  return useMutation(SUBMIT_CANCELLATION_MUTATION, {
    variables: {
      objectId
    },
    onCompleted: async response => {
      const responseUserErrors = response.response.userErrors;
      if (responseUserErrors.length) {
        await handleError();
        return;
      }
      addAlert({
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "subscriptions.SubscriptionCancellationModal.successfullyCanceledTitle"
        }),
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "subscriptions.SubscriptionCancellationModal.successfullyCanceledMessage"
        }),
        type: 'success'
      });
      trackUsage('cancelSubscriptionModalSubmitted');
      await onClose();
    },
    onError: async () => await handleError()
  });
}